<div #heatmapContainer></div>

